import { FeedbackVideo } from "@/components/feedback/FeedbackVideo";

export const InviteProductVisual = () => (
  <div className="relative mx-auto mt-8 w-full max-w-[528px]" data-testid="invite-product-presentation">
    <div className="relative flex aspect-[4/5] w-full items-center justify-center overflow-hidden border border-white/20 bg-[color:var(--bg-soft)]" data-testid="invite-product-visual">
      <FeedbackVideo poster="/media/vitura-blend-poster.jpg" className="absolute inset-0 h-full w-full object-cover" data-testid="invite-blend-video" aria-label="Vitura ingredients being measured and blended in the lab">
        <source src="/media/vitura-blend.webm" type="video/webm" />
        <source src="/media/vitura-blend.mp4" type="video/mp4" />
      </FeedbackVideo>
    </div>
  </div>
);